<template>
    <el-dialog :title="info.title" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
        <div class="dialog-box">
            <div class="cont txt-14">
                <img :src="info.image" />
                <div v-html="info.content"></div>
            </div>
        </div>
        <div class="but" @click="dialogVisible = false">{{ $t('我知道了') }}</div>
    </el-dialog>
</template>
<script>
export default {
    props: {
    },
    data() {
        return {
            dialogVisible: false,
            info: {}
        };
    },
    watch: {
    },
    created() {
    },
    methods: {
        open(data) {
            this.dialogVisible = true
            this.info = data
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0px;
}

::v-deep .el-dialog__header {
    .el-dialog__title {
        color: #fff;
    }

    padding-bottom: 15px;
    background-color: #1a222b;
}

.dialog-box {
    background-color: #12141e;
    padding: 40px;

    .cont {
        height: 320px;
        overflow-y: auto;

        img {
            margin: auto;
        }

        >div {
            margin-top: 20px;
        }
    }

}

.but {
    width: 350px;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    color: rgb(0, 0, 0);
    border-radius: 99px;
    background: rgb(0, 240, 255);
    text-align: center;
    cursor: pointer;
    margin: 20px auto;
}
</style>